"use strict";

var _interopRequireDefault = require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.find");
require("core-js/modules/es6.function.name");
var _regeneratorRuntime2 = _interopRequireDefault(require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _vDistpicker = _interopRequireDefault(require("v-distpicker"));
var _validate = require("@/utils/validate.js");
var _configure = require("@/api/configure");
var _security = require("@/utils/security");
var _encryptKey = require("@/config/encryptKey");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//定义一个全局的变量
var validPhone = function validPhone(rule, value, callback) {
  if (!value) {
    callback(new Error('请输入电话号码'));
  } else if (!(0, _validate.isvalidPhone)(value)) {
    callback(new Error('请输入正确的11位手机号码'));
  } else {
    callback();
  }
};
var _default = {
  name: 'arbitratorMaintenance',
  data: function data() {
    return {
      tableHeaderColor: this.$tableHeaderColor,
      name: '',
      //姓名
      rolevalue: '',
      //仲裁委值
      statevalue: '',
      //状态值
      stateArr: [{
        //状态数组
        value: '1',
        label: '已启用'
      }, {
        value: '0',
        label: '已禁用'
      }],
      commiteeArr: [],
      loading: true,
      tableData: [],
      currentPage: 1,
      pageLimit: 10,
      //每页请求多少个数据，默认10
      pageSizes: this.$tablePageSizes,
      total: 0,
      addPersonVisible: false,
      //添加人员显示
      addtitle: '',
      //  添加人员/编辑标题
      addAccountVisible: false,
      //创建账号显示
      addAccountTitle: '',
      //创建账号/查看 标题
      addPersonForm: {
        //添加人员数据
        name: '',
        phone: '',
        commitee: '',
        speciality: '',
        address: '',
        // {province: '广东省', city: '广州市', area: '天河区'}
        // addressDetail:'',
        post: '',
        status: '启用'
      },
      addPersonRules: {
        name: [{
          required: true,
          message: '请输入姓名'
        }],
        speciality: [{
          required: true,
          message: '请输入专长'
        }],
        commitee: [{
          required: true,
          message: '请选择仲裁委'
        }],
        phone: [{
          required: true,
          message: '请输入电话号码',
          validator: validPhone
        }],
        post: [{
          required: true,
          message: '请输入职务'
        }],
        address: [{
          required: true,
          message: '请输入地址'
        }],
        status: [{
          required: true,
          message: '请选择状态'
        }]
      },
      addAccountForm: {
        account: '',
        password: '',
        phone: ''
      },
      addAccountFormRules: {
        account: [{
          required: true,
          message: '请输入账号名称'
        }],
        password: [{
          required: true,
          message: '请输入密码'
        }],
        phone: [{
          required: true,
          message: '请输入电话号码',
          validator: validPhone
        }]
      },
      currentPersonId: '',
      fileList: [],
      //上传的图片
      action: process.env.VUE_APP_BASE_API + (0, _configure.uploadArbitratoSign)(),
      headers: {
        'Authorization': localStorage.getItem('token')
      },
      uploadSuccessImg: '',
      //已经上传成功的文件
      uploadTip: false,
      sign: '',
      commName: '',
      CommonPath: '',
      commId: ''
    };
  },
  components: {
    VDistpicker: _vDistpicker.default
  },
  created: function created() {
    this.currentPage = 1;
    this.init();
  },
  methods: {
    init: function () {
      var _init = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var _this = this;
        var _yield$getArbitratorL, rows, total;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              // 获取仲裁委列表
              (0, _configure.getAllCommission)({}).then(function (res) {
                if (res.code == 1) {
                  _this.commiteeArr = res.data;
                }
              });
              _context.next = 3;
              return (0, _configure.getArbitratorList)({
                limit: this.pageLimit,
                page: this.currentPage
              });
            case 3:
              _yield$getArbitratorL = _context.sent;
              rows = _yield$getArbitratorL.rows;
              total = _yield$getArbitratorL.total;
              this.tableData = rows;
              this.total = total;
              this.loading = false;
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function init() {
        return _init.apply(this, arguments);
      }
      return init;
    }(),
    //添加人员
    gotoCreate: function gotoCreate() {
      this.addPersonVisible = true;
      this.addtitle = '添加人员';
      if (this.$refs['addPersonForm']) {
        this.$refs['addPersonForm'].resetFields();
      }
    },
    //角色变化事件
    roleChange: function roleChange(val) {},
    //状态变化事件
    stateChange: function stateChange() {},
    //筛选
    screen: function () {
      var _screen = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        var _yield$getArbitratorL2, rows, total;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.currentPage = 1;
              _context2.next = 3;
              return (0, _configure.getArbitratorList)({
                commId: this.rolevalue,
                name: this.name,
                status: this.statevalue,
                limit: this.pageLimit,
                page: this.currentPage
              });
            case 3:
              _yield$getArbitratorL2 = _context2.sent;
              rows = _yield$getArbitratorL2.rows;
              total = _yield$getArbitratorL2.total;
              this.tableData = rows;
              this.total = total;
              this.loading = false;
            case 9:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function screen() {
        return _screen.apply(this, arguments);
      }
      return screen;
    }(),
    //点击 清空所有筛选条件
    clearAllConditon: function clearAllConditon() {
      this.rolevalue = '';
      this.name = "";
      this.statevalue = '';
      this.currentPage = 1;
      this.init();
    },
    // 表格恢复初始值
    resetTableList: function () {
      var _resetTableList = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3() {
        var _yield$getArbitratorL3, rows, total, _yield$getArbitratorL4, _rows, _total;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!(this.name || this.statevalue || this.rolevalue)) {
                _context3.next = 11;
                break;
              }
              _context3.next = 3;
              return (0, _configure.getArbitratorList)({
                commId: this.rolevalue,
                name: this.name,
                status: this.statevalue,
                limit: this.pageLimit,
                page: this.currentPage
              });
            case 3:
              _yield$getArbitratorL3 = _context3.sent;
              rows = _yield$getArbitratorL3.rows;
              total = _yield$getArbitratorL3.total;
              this.tableData = rows;
              this.total = total;
              this.loading = false;
              _context3.next = 19;
              break;
            case 11:
              _context3.next = 13;
              return (0, _configure.getArbitratorList)({
                limit: this.pageLimit,
                page: this.currentPage
              });
            case 13:
              _yield$getArbitratorL4 = _context3.sent;
              _rows = _yield$getArbitratorL4.rows;
              _total = _yield$getArbitratorL4.total;
              this.tableData = _rows;
              this.total = _total;
              this.loading = false;
            case 19:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function resetTableList() {
        return _resetTableList.apply(this, arguments);
      }
      return resetTableList;
    }(),
    //表格  删除
    deletePerson: function deletePerson(val) {
      var _this2 = this;
      this.$confirm('是否删除该仲裁员？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _configure.deleteArbitrator)({
          id: val.id
        }).then(function (res) {
          if (res.code == 1) {
            _this2.$message({
              message: '删除成功',
              type: 'success'
            });
            _this2.resetTableList();
          }
        });
      }).catch(function () {
        _this2.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    // 表格  查看/修改
    checkPerson: function checkPerson(val, title) {
      var _this3 = this;
      this.addtitle = title;
      this.addPersonVisible = true;
      if (this.$refs['addPersonForm']) {
        this.$refs['addPersonForm'].resetFields();
      }
      if (title == '修改人员') {
        this.currentPersonId = val.id;
      }
      (0, _configure.checkArbitrator)(val.id).then(function (res) {
        if (res.code == 1) {
          var commiteeItem = _this3.commiteeArr.find(function (ele) {
            return ele.id == res.data.commId;
          });
          _this3.addPersonForm.name = res.data.name;
          _this3.addPersonForm.address = res.data.address;
          _this3.addPersonForm.phone = res.data.mobile;
          _this3.addPersonForm.speciality = res.data.expertise;
          _this3.addPersonForm.post = res.data.jobs;
          _this3.addPersonForm.status = res.data.status == 1 ? '启用' : '禁用';
          _this3.addPersonForm.commitee = commiteeItem.name;
        }
      });
    },
    //表格   修改
    modifyPerson: function modifyPerson() {
      this.addPersonVisible = true;
      this.addtitle = '编辑人员';
    },
    //创建账号
    foundAccount: function () {
      var _foundAccount = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee4(val, title) {
        var _yield$getArbitratorA, data;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              this.addAccountVisible = true;
              this.addAccountTitle = title;
              this.currentPersonId = val.id;
              this.commName = val.commName;
              this.commId = val.commId;
              if (this.$refs['addAccountForm']) {
                this.$refs['addAccountForm'].resetFields();
              }
              if (!(title == '查看账号')) {
                _context4.next = 16;
                break;
              }
              _context4.next = 9;
              return (0, _configure.getArbitratorAccount)(val.adminId);
            case 9:
              _yield$getArbitratorA = _context4.sent;
              data = _yield$getArbitratorA.data;
              this.addAccountForm.account = data.account;
              this.addAccountForm.password = data.password;
              this.addAccountForm.phone = data.mobile;
              // this.CommonPath = data.img;
              _context4.next = 20;
              break;
            case 16:
              this.sign = '';
              this.fileList = [];
              this.uploadTip = false;
              this.addAccountVisible = true;
            case 20:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function foundAccount(_x, _x2) {
        return _foundAccount.apply(this, arguments);
      }
      return foundAccount;
    }(),
    //提交创建账号表单
    submitAccountForm: function submitAccountForm(formName) {
      var _this4 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid && _this4.uploadSuccessImg) {
          (0, _configure.addArbitratorAccount)({
            account: _this4.addAccountForm.account,
            email: '',
            mobile: _this4.addAccountForm.phone,
            arbitratorId: _this4.currentPersonId,
            password: _this4.addAccountForm.password,
            img: _this4.uploadSuccessImg,
            noticeFile: _this4.CommonPath
          }).then(function (res) {
            if (res.code == 1) {
              _this4.$message({
                message: '创建账号成功',
                type: 'success'
              });
              _this4.$refs[formName].resetFields();
              _this4.addAccountVisible = false;
              _this4.uploadTip = true;
              _this4.resetTableList();
            } else {
              _this4.$message({
                message: res.msg,
                type: 'warn'
              });
            }
          });
        } else {
          _this4.uploadTip = true;
          return false;
        }
      });
    },
    //人员修改/添加提交表单
    submitPartyForm: function submitPartyForm(formName) {
      var _this5 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          var commiteeItem = _this5.commiteeArr.find(function (ele) {
            return ele.name == _this5.addPersonForm.commitee;
          });
          if (_this5.addtitle == '修改人员') {
            (0, _configure.updateArbitrator)({
              name: _this5.addPersonForm.name,
              expertise: _this5.addPersonForm.speciality,
              commId: commiteeItem.id,
              commName: _this5.addPersonForm.commitee,
              address: _this5.addPersonForm.address,
              mobile: _this5.addPersonForm.phone,
              jobs: _this5.addPersonForm.post,
              id: _this5.currentPersonId,
              status: _this5.addPersonForm.status == '启用' ? '1' : '0'
            }).then(function (res) {
              if (res.code == 1) {
                _this5.$message({
                  message: '修改成功',
                  type: 'success'
                });
                _this5.$refs[formName].resetFields();
                _this5.addPersonVisible = false;
                _this5.resetTableList();
              }
            });
          } else if (_this5.addtitle == '添加人员') {
            (0, _configure.addArbitrator)({
              name: _this5.addPersonForm.name,
              expertise: _this5.addPersonForm.speciality,
              commId: commiteeItem.id,
              commName: commiteeItem.name,
              address: _this5.addPersonForm.address,
              mobile: _this5.addPersonForm.phone,
              jobs: _this5.addPersonForm.post,
              status: _this5.addPersonForm.status == '启用' ? '1' : '0'
            }).then(function (res) {
              if (res.code == 1) {
                _this5.$message({
                  message: '添加成功',
                  type: 'success'
                });
                _this5.$refs[formName].resetFields();
                _this5.addPersonVisible = false;
                _this5.resetTableList();
              }
            });
          }
        } else {
          return false;
        }
      });
    },
    // 分页事件
    handleSizeChange: function handleSizeChange(val) {
      this.pageLimit = val;
      this.resetTableList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.currentPage = val;
      this.resetTableList();
    },
    handleRemove: function handleRemove(file, fileList) {
      if (fileList.length == 0) {
        this.uploadSuccessImg = '';
        this.uploadTip = true;
      }
    },
    handlePreview: function handlePreview(file) {
      if (file.url) {
        window.open(file.url);
      } else {
        var res = JSON.parse((0, _security.decryptByAES)(file.response.response, _encryptKey.encryptKey.key));
        if (res.code == 1) {
          window.open(res.data.href);
        } else {
          location.reload();
        }
      }
    },
    handleExceed: function handleExceed(files, fileList) {
      this.$message.warning("\u5F53\u524D\u9650\u5236\u9009\u62E9 1 \u4E2A\u6587\u4EF6\uFF0C\u672C\u6B21\u9009\u62E9\u4E86 ".concat(files.length, " \u4E2A\u6587\u4EF6\uFF0C\u5171\u9009\u62E9\u4E86 ").concat(files.length + fileList.length, " \u4E2A\u6587\u4EF6"));
    },
    beforeRemove: function beforeRemove(file, fileList) {
      return this.$confirm("\u786E\u5B9A\u79FB\u9664 ".concat(file.name, "\uFF1F"));
    },
    handleSuccess: function handleSuccess(res1, file, fileList) {
      var _this6 = this;
      var res = JSON.parse((0, _security.decryptByAES)(res1.response, _encryptKey.encryptKey.key));
      if (res.code == 1) {
        this.uploadSuccessImg = res.data.path;
        this.uploadTip = false;
        (0, _configure.addArbitratoSign)({
          id: this.currentPersonId,
          img: res.data.path,
          commName: this.commName,
          commId: this.commId
        }).then(function (res) {
          if (res.code == 1) {
            _this6.sign = res.data.href;
            _this6.CommonPath = res.data.path;
          }
        });
      } else {
        location.reload();
      }
    }
  }
};
exports.default = _default;